<template>
  <f7-page id="page-account-invite-earn" name="account-invite-earn" class="bg-color-white" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block class="mt-xxl mb-xxl">
      <p class="wandr-title-1 mb-0 fw-bold">{{$t('account-invite-earn')}}</p>
      <p class="text-color-gray2 mb-0">
        <span>Love our service? Don't keep us a secret!<br/></span>
        <span>{{$t('account-invite-earn-text', {amount:couponAmount})}}</span>
      </p>
    </f7-block>

    <f7-block>
      <div class="card">
        <div class="card-header d-block bg-color-primary padding text-align-center text-color-white">{{$t('account-invite-earn-copy-card-header')}}</div>
        <div class="card-content card-content-padding">
          <div class="card card-18 display-flex align-items-center justify-content-space-between">
            <div class="referal-link text-color-gray2" ref="invitelink" id="invitelink">{{invitelink}}</div>
            <div>
              <img :src="require('@/assets/img/icon/icon-copy.svg')" @click="copyText('invitelink')" class="filter-icon pointer">
            </div>
          </div>
        </div>
      </div>

      <p class="text-color-gray2 mt-xxl pt-3">
        {{$t('account-invite-earn-text-bottom', {amount:couponAmount})}}
      </p>

      <p class="text-color-gray2 fs-12 pointer" v-html="$t('account-invite-earn-tnc')" @click="redirectToIETNC()"></p>
    </f7-block>



  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    data() {
			return {
        invitelink   : "",
        couponAmount : 20
			}
		},
    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.init();
    },
		computed: {
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess'
			])
		},
    methods: {
      ...mapActions('auth', ['login']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      init(){
        const self = this
        self.showPreloader()

        const referralCodePromise = self.$api.customerLoyalty.getInviteLink()
        referralCodePromise.then(function(result) {
          self.invitelink = process.env.VUE_APP_MARKETING + "invite?ref=" +result.referralCode
        })

        const getDiscountDetailPromise = self.$api.customerLoyalty.getDiscountDetail(process.env.VUE_APP_INVITE_EARN_CAMPAIGN_ID)
        getDiscountDetailPromise.then(function(result) {
          self.couponAmount = result[0].feeDiscount
        })

        self.hidePreloader()
      },

      copyText(text){
        // var marketingShareText = "Register with Wandr-E for FREE and send money worldwide at competitive rates with no fees!\r\n\r\nHi, you have been invited by your friend to sign up with us!\r\nClick on this link to find out more.\r\n\r\n\r\n"

        var copyText = document.getElementById(text);
        var textArea = document.createElement("textarea");
        textArea.value = copyText.textContent;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();

        this.$f7.toast.create({
          text: 'Link copied',
          position: 'center',
          closeTimeout: 1000,
        }).open()
      },

      redirectToIETNC(){
        this.$f7router.navigate("/invite-earn-tnc" , { transition: 'f7-push'});
      },

      backButton(){
        this.$f7router.back({ transition: 'f7-push' })
      }

    }
  }
</script>